import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  FileStatusParams,
  liquidationService,
} from "../../../../../api/services/liquidationService";

export const liquidationKeys = {
  all: ["liquidation"] as const,
  fileStatus: (params: FileStatusParams) =>
    [...liquidationKeys.all, "fileStatus", params] as const,
};

export function useFileStatus(
  params: FileStatusParams,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: liquidationKeys.fileStatus(params),
    queryFn: async () => {
      try {
        const response = await liquidationService.getFileStatus(params);
        return response.data || [];
      } catch (error) {
        console.error("Error fetching file status:", error);
        return [];
      }
    },
    enabled,
    refetchInterval: enabled ? 5000 : false,
    staleTime: 0,
    retry: false,
  });
}

export function useInvalidateFileStatus() {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: liquidationKeys.all,
      predicate: (query) => {
        const key = query.queryKey;
        return key[0] === "liquidation" && key[1] === "fileStatus";
      },
    });
  };
}
